import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "10", y1: "15", y2: "9", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "14", y1: "15", y2: "9", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "PauseCircle";
const PauseCircle = memo(themed(Icon));
export {
  PauseCircle
};
//# sourceMappingURL=pause-circle.js.map
